import { isBefore } from 'date-fns';

/**
 * Transforms group of exchangeables of type 'Trip'.
 *
 * A group of exchangeables equals multiple exchangeable reservations (fulfillments) for the same trip.
 *
 * e.g. 2 pax for the same trip to "Joch" will create a group with 2 exchangeables.
 * Up & Down for 2pax = 2 groups with 2 exchangeables each.
 */
export function transformExchangeableGroupsTrip(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Reservation')
        .filter(bp => bp.status !== 'REFUNDED')
        .reduce<ExchangeableGroupTrip[]>((list, bookingPart) => {
            assignReservation(list, bookingPart, apiBooking);
            return list;
        }, [])
        .slice() // create a shallow copy to avoid mutating the original array when sorting
        .sort((a, b) => a.trip && b.trip && isBefore(a.trip.departureTime, b.trip.departureTime) ? -1 : 1);
}

/**
 * Group/Reduce exchangeable reservations to the same trip
 */
function assignReservation(
    list: ExchangeableGroupTrip[],
    reservation: ApiSchema['Reservation'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Trip';
    const exchangeable = transformExchangeableReservation(reservation, apiBooking);
    const trip = exchangeable.trip;
    const id = trip?.id ?? '';

    let exchangeableGroup = list
        .filter(eg => eg.type === type)
        .find(p => p.id === id);
    if (!exchangeableGroup) {
        exchangeableGroup = {
            id,
            type,
            trip,
            exchangeables: [],
        };
        list.push(exchangeableGroup);
    }

    exchangeableGroup.exchangeables.push(exchangeable);
}
